import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "financelocal:cookie-consent";

/**
 * Slim, single-line cookie banner.
 *
 * Mobile: 1-line, ~40 px tall, sticky at the bottom, dismissable.
 * Desktop: ~36 px tall, never wraps unless the viewport is < 400 px wide.
 */
export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);
  const accept = () => { localStorage.setItem(KEY, "accepted"); setShow(false); };
  if (!show) return null;
  return (
    <div data-testid="cookie-banner"
      role="region" aria-label="Cookie notice"
      className="fixed bottom-0 inset-x-0 z-40 bg-zinc-900/95 dark:bg-zinc-950/95 text-zinc-100 border-t border-zinc-800 backdrop-blur supports-[backdrop-filter]:bg-zinc-900/85">
      <div className="mx-auto max-w-7xl px-3 sm:px-4 h-9 sm:h-10 flex items-center gap-2 text-[11px] sm:text-xs">
        <span className="flex-1 truncate">
          <span className="hidden sm:inline">FinanceLocal uses one first-party session cookie for authentication only.</span>
          <span className="sm:hidden">First-party auth cookie only.</span>
          {" "}
          <Link to="/legal?t=privacy" className="underline underline-offset-2 hover:text-amber-300">
            Privacy Policy
          </Link>
        </span>
        <button data-testid="cookie-accept" onClick={accept}
          className="px-2.5 h-6 sm:h-7 bg-amber-400 text-zinc-900 hover:bg-amber-300 font-semibold uppercase tracking-wider text-[10px] sm:text-xs whitespace-nowrap">
          Got It
        </button>
        <button data-testid="cookie-dismiss" onClick={accept} aria-label="Dismiss"
          className="hidden sm:inline-flex w-6 h-6 items-center justify-center hover:bg-zinc-800 rounded">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
